import PropTypes from 'prop-types';
import styled from 'helpers/styles';
import {css} from 'styled-components';
import ComponentStyles from 'styles/mixins/Component.styles';
import Box from 'components/atoms/Layout/Box/Box';
import utils from 'helpers/utils';

const StyledFormField = styled(Box)
  .attrs((props) => {
    let attr = props;

    const vars = {
      '--form-field-min-width': utils.isDefined(props.$minWidth) ? props.theme.layout(props.$minWidth) : null,
      '--form-field-max-width': utils.isDefined(props.$maxWidth) ? props.theme.layout(props.$maxWidth) : null
    };

    return utils.styleProps(attr, vars);
  })`
  ${props => utils.isDefined(props.$minWidth) ? css`
    width: ${props => props.$css.$var('--form-field-min-width', false)} !important;
    min-width: ${props => props.$css.$var('--form-field-min-width', false)} !important;
  ` : css``}

  ${props => utils.isDefined(props.$maxWidth) ? css`
    max-width: ${props => props.$css.$var('--form-field-max-width', false)} !important;
  ` : css``}
  
  &.FormField-hidden {
    display: none !important;
  }
  
  ${ComponentStyles}
`;

StyledFormField.propTypes = {
  theme: PropTypes.object
};

export default StyledFormField;
